import { Hash } from "lucide-react";

const input = "w-full bg-white border border-navy/10 rounded-lg px-3 py-2 text-sm outline-none focus:border-violet transition-colors";

// Encabezado del presupuesto: folio (manual/auto) + campos del encabezado.
// props: terms (obj), onTerm(key,val), folio (string manual), onFolio(val), currentFolio (folio ya asignado), disabled
export default function QuoteHeaderFields({ terms = {}, onTerm, folio = "", onFolio, currentFolio = "", disabled = false }) {
  const F = (label, key, type = "text") => (
    <div>
      <label className="text-xs text-navy/50 block mb-1">{label}</label>
      <input type={type} className={input} value={terms[key] || ""} onChange={(e) => onTerm(key, e.target.value)} data-testid={`qh-${key}`} />
    </div>
  );
  return (
    <div className="space-y-3" data-testid="quote-header-fields">
      <div className="text-sm font-medium text-navy flex items-center gap-1.5"><Hash className="w-4 h-4 text-violet" /> Encabezado del presupuesto</div>
      <div>
        <label className="text-xs text-navy/50 block mb-1">Folio / número de presupuesto</label>
        <input className={input} value={folio} onChange={(e) => onFolio(e.target.value)}
          placeholder={currentFolio ? `Actual: ${currentFolio} (deja vacío para conservarlo)` : "Automático (deja vacío) o escribe uno manual"}
          data-testid="qh-folio" />
        <p className="text-[11px] text-navy/40 mt-1">Deja vacío para usar el folio automático, o escribe uno manual (letras, números y signos).</p>
      </div>
      <div className="grid sm:grid-cols-2 gap-3">
        {F("Cliente", "h_cliente")}
        {F("Cuenta", "h_cuenta")}
        {F("Contacto", "h_contacto")}
        {F("Versión", "h_version")}
        {F("Elaboró", "h_elaboro")}
        {F("Tipo de servicio", "h_tipo_servicio")}
        {F("Proyecto", "h_proyecto")}
        {F("Locación / Plaza", "h_locacion")}
        {F("Fecha de ejecución", "h_fecha_ejecucion", "date")}
      </div>
      <div>
        <label className="text-xs text-navy/50 block mb-1">Otros detalles</label>
        <textarea rows={2} className={input} value={terms.h_otros || ""} onChange={(e) => onTerm("h_otros", e.target.value)} data-testid="qh-h_otros" />
      </div>
    </div>
  );
}
